import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import * as actions from './actions'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const state = {
  channel: null,
  channel_id: '',
  user: null,
  page: null,
  page_id: '',
  pages: [],
  tiers: null,
  confirm_delete_page: null,
  fans: null
}

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state,
  actions,
  mutations
})
